import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InvitationResponse} from '../../models/invitationResponse';
import {faUserFriends} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {UiButtonComponent} from '../../shared/ui';

@Component({
  selector: 'app-invitations',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    UiButtonComponent,
  ],
  templateUrl: './invitations.component.html',
  styleUrls: ['./invitations.component.scss'],
})
export class InvitationsComponent {

  @Input() invites: InvitationResponse[] = [];
  @Input() mode: 'desktop-dropdown' | 'mobile-inline' = 'desktop-dropdown';

  @Output() acceptInvitationRequested = new EventEmitter<number>();
  @Output() rejectInvitationRequested = new EventEmitter<number>();
  @Output() closeRequested = new EventEmitter<void>();

  readonly faInvitationIndicator = faUserFriends;

  accept(invitationId: number): void {
    this.acceptInvitationRequested.emit(invitationId);
  }

  reject(invitationId: number): void {
    this.rejectInvitationRequested.emit(invitationId);
  }

  requestClose(): void {
    this.closeRequested.emit();
  }

}
